module.exports = __webpack_public_path__ + "static/img/n-clock-duration.9d6f74e7.png";